
import { Component, Vue } from 'vue-property-decorator'
import { CommonService } from '@/services/index'
import UploadImg from '@/components/upload_img/index.vue'

@Component({
    name: 'SettingBanner',
    components: {
        UploadImg
    }
})
export default class extends Vue {
    private bannerUrl: string = ''

    private mounted() {
        this.getHomeBanner()
    }

    private async getHomeBanner() {
        const result = await CommonService.getHomeBanner()
        if (result.status === 200) {
            this.bannerUrl = result.data
        }
    }

    private async uploadCallback(url: string) {
        const result = await CommonService.updateHomeBanner({ img_name: url })
        if (result.status === 200) {
            this.$message({ type: 'success', message: '上传成功' })
            this.bannerUrl = result.data.img_url
        }
    }

    private async onResetDefault() {
        const result = await CommonService.updateHomeBanner({ img_name: '' })
        if (result.status === 200) {
            this.$message({ type: 'success', message: '重置成功' })
            this.bannerUrl = result.data.img_url
        }
    }
}
